import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_APPSEBRAE}${process.env.VUE_APP_API_PATH}/appsebrae/consultorias/unidadesregionais`

export default {
    obterTodas() {
        return axiosJwt
            .get(
                `${api}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGestores() {
        return axiosJwt
            .get(
                `${api}/gestores`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/dotacoes/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProjetos(codUnidade) {
        return axiosJwt
            .get(
                `${api}/dotacoes/unidades/${codUnidade}/projetos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoes(codUnidade, codProjeto) {
        return axiosJwt
            .get(
                `${api}/dotacoes/unidades/${codUnidade}/projetos/${codProjeto}/acoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(unidadeRegionalId) {
        return axiosJwt
            .get(`${api}/${unidadeRegionalId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMunicipiosDisponiveis(unidadeRegionalId) {
        return axiosJwt
            .get(`${api}/${unidadeRegionalId}/municipios/disponiveis`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserir(unidadeRegionalDto) {
        return axiosJwt
            .post(`${api}/inserir`, unidadeRegionalDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizar(unidadeRegionalDto) {
        return axiosJwt
            .post(`${api}/atualizar`, unidadeRegionalDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirMunicipio(municipioDto) {
        return axiosJwt
            .post(`${api}/municipios/inserir`, municipioDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirMunicipio(municipioId) {
        return axiosJwt
            .patch(`${api}/municipios/excluir/${municipioId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
